import { CurrencyPrefixList } from './prefixList';

export default countryId => {
  const country = CurrencyPrefixList.find(value => value.name === countryId);
  return country && country.prefix;
};
